module.exports = __webpack_public_path__ + "img/group_invite_icon.99abfb33.png";